<template>
  <div>
    <div class="grid grid-cols-12 gap-4">
      <div
        v-for="(address, key) in form.addresses"
        :key="key"
        class="input-group col-span-12 sm:col-span-12"
      >
        <div class="input-append">
          <div class="input-control">
            <input
              type="text"
              v-model="address.value"
              @change="addressChanged"
              placeholder="Enter sub-region address"
            />
          </div>
          <button
            @click="removeAddress(key)"
            type="button"
            class="input-addon"
          >
            <span>-</span>
          </button>
        </div>
      </div>
    </div>

    <div class="pt-4">
      <div class="flex">
        <button
          type="button"
          @click.prevent="newAddress"
          :disabled="form.processing"
          class="btn btn-link"
        >
          + New
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    addresses: {
      type: Array,
      required: true
    }
  },

  mixins: [],
  components: {},

  data() {
    return {
      form: {
        addresses: []
      },
      addressDefault: {
        value: ''
      }
    }
  },

  created() {
    this.addresses.forEach((address) => {
      this.appendAddress(address)
    })
  },

  computed: {},

  methods: {
    appendAddress(value = '') {
      this.form.addresses.push({
        ...this.addressDefault,
        value: value
      })
    },
    newAddress() {
      this.appendAddress()
      this.emitAddresses()
    },
    removeAddress(key) {
      this.form.addresses = _.remove(this.form.addresses, function (address, i) {
        return i !== key
      })
      this.emitAddresses()
    },
    addressChanged(event) {
      this.emitAddresses()
    },
    emitAddresses() {
      const addresses = _.map(this.form.addresses, function (address) {
        return address.value
      })

      this.$emit('update:addresses', addresses)
    }
  }
}
</script>
